class HeroSlider {
  touchstartY = 0;
  touchendY = 0;

  slideIndex = 0;
  lastScrollTop = 0;

  shouldAnimate = true;
  inAnimation = false;

  constructor() {
    this.sliderRef = document.querySelector('.lc-hero-slider');

    window.heroSlider = this;

    if (this.sliderRef) {
      this.styleRef = document.createElement('style');

      const nextSibling = document.querySelector('.lc-hero-slider + h2');
      if (nextSibling && !nextSibling.id) {
        nextSibling.id = nextSibling.innerText.replaceAll(' ', '-').replaceAll(',', '');
      }

      this.slides = this.sliderRef.querySelectorAll('.lc-hero-slider-item');
      if(this.slides.length < 2) return;
      this.setupSlides();
      this.setupSideNav();
      document.querySelector('.iz-content__content').append(this.styleRef);

      if (window.location.hash == '' && window.scrollY == 0) {
        history.replaceState(undefined, undefined, `#${this.slides[0]?.id}`);
        this.e_hashChange();
        this.updateStyleScroll();
      } else if (![...this.slides].find(s => `#${s.id}` === window.location.hash)) {
        this.slideIndex = this.slides.length;
        this.updateStyleScroll();
      } else {
        this.e_hashChange();
        this.updateStyleScroll();
      }

      this.bindEvents();
    }
  }

  bindEvents() {
    window.addEventListener('wheel', this.e_mouseWheelScroll);
    window.addEventListener('touchstart', this.e_touchStart, false);
    window.addEventListener('touchend', this.e_touchEnd, false);
    window.addEventListener('hashchange', this.e_hashChange, false);
  }

  unbindEvents() {
    window.removeEventListener('wheel', this.e_mouseWheelScroll);
    window.removeEventListener('touchstart', this.e_touchStart, false);
    window.removeEventListener('touchend', this.e_touchEnd, false);
    window.removeEventListener('hashchange', this.e_hashChange, false);
  }

  toggleSidenav() {
    this.sideNav.style.display = this.slideIndex == this.slides.length ? 'none' : 'block';
    this.sideNavItems.forEach(item => item.classList.remove('active'));
    this.sideNavItems[this.slideIndex].classList.add('active');
  }


  setupSideNav() {
    this.sideNav = document.createElement('div');
    this.sideNav.classList.add('lc-hero-slider__sidenav');
    this.sliderRef.appendChild(this.sideNav);

    this.slides.forEach((slide, slideIndex) => {
      this.sideNav.innerHTML += `<div class="lc-hero-slider__sidenav-item" data-target="${slideIndex}" data-hash="${slide.id}"><span>${slide.querySelector('.lc-hero-slider-item__anchor')?.innerText?.toUpperCase()}</span></div>`;
    });

    const nextSibling = document.querySelector('.lc-hero-slider + h2');

    if (nextSibling) {
      this.sideNav.innerHTML += `<div class="lc-hero-slider__sidenav-item" data-target="${this.slides.length}" data-hash="${nextSibling.id}"><span>${nextSibling.innerText.toUpperCase()}</span></div>`;
    }

    this.sideNavItems = [...this.sideNav.querySelectorAll('.lc-hero-slider__sidenav-item')];

    this.sideNavItems.forEach(item => {
      item.addEventListener('click', (e) => {
        this.slideIndex = item.dataset.target;
        history.replaceState(undefined, undefined, `#${item.dataset.hash}`);
        this.e_hashChange();
        this.updateStyleScroll();
      });
    });
  }

  setupSlides() {
    this.slides.forEach(slide => {
      const slideTitle = slide.querySelector(".lc-hero-slider-item__anchor");
      slide.id = slideTitle.innerText?.toLowerCase().replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '').replaceAll('\'', '');
    })
  }

  e_hashChange(event) {
    const activeSlideHash = [...window.heroSlider.slides].find(slide => `#${slide.id}` == window.location.hash);

    if (activeSlideHash) {
      window.scrollTo({top: 0, behavior: 'instant'});
      window.heroSlider.slideIndex = [...window.heroSlider.slides].indexOf(activeSlideHash);
      window.heroSlider.updateStyleScroll();
    }
  }

  handleGesture() {
    if (!window.heroSlider.inAnimation || !window.heroSlider.shouldAnimate) {
      if (window.scrollY > 0) {
        return;
      } else {
        if (window.heroSlider.touchendY > window.heroSlider.touchstartY) {
          if (window.heroSlider.slideIndex != 0) { // should scroll to prev slide?
            window.heroSlider.scrollPrevSlide();
            return;
          }
        }
      }
    }

    if (window.heroSlider.touchendY < window.heroSlider.touchstartY) {
      window.heroSlider.scrollNextSlide();
    }
    if (window.heroSlider.touchendY > window.heroSlider.touchstartY) {
      if (window.heroSlider.slideIndex != 0) { // should scroll to prev slide?
        window.heroSlider.scrollPrevSlide();
      }
    }
  }

  e_touchStart(event) {
    window.heroSlider.touchstartY = event.touches[0].clientY;

  }

  e_touchEnd(event) {
    window.heroSlider.touchendY = event.changedTouches[0].clientY;
    window.heroSlider.handleGesture();
  }

  e_mouseWheelScroll(e) {
    window.heroSlider.mouseWheelScroll(e);
  };

  mouseWheelScroll(event) {
    if (!window.heroSlider.inAnimation && window.heroSlider.shouldAnimate) {
      if (event.deltaY < 0) {
        if (window.heroSlider.slideIndex != 0) { // should scroll to prev slide?
          window.heroSlider.scrollPrevSlide();
        }
      } else {
        if (window.heroSlider.slideIndex < window.heroSlider.slides.length)
          window.heroSlider.scrollNextSlide();
      }
    }

    if (event.deltaY < 0 && !window.heroSlider.shouldAnimate && window.scrollY === 0) {
      window.heroSlider.scrollPrevSlide();
    }
  }

  scrollNextSlide() {
    if (window.heroSlider.slideIndex < window.heroSlider.slides.length && !window.heroSlider.inAnimation) {
      if (window.heroSlider.slideIndex + 1 < window.heroSlider.slides.length) {
        history.replaceState(undefined, undefined, `#${window.heroSlider.slides[window.heroSlider.slideIndex + 1].id}`);

        window.heroSlider.e_hashChange();
        window.scrollTo({y: 0, behavior: 'instant'});
      } else {
        // scroll slider outside of view
        window.heroSlider.slideIndex++;
        // set hash to first id on page
        const nextSibling = document.querySelector('.lc-hero-slider + h2');

        if (nextSibling) {
          history.replaceState(undefined, undefined, `#${nextSibling.id}`);
          window.heroSlider.updateStyleScroll();
        }
      }
    }
  }

  scrollPrevSlide() {
    if (window.heroSlider.slideIndex - 1 >= 0 && !window.heroSlider.inAnimation) {
      history.replaceState(undefined, undefined, `#${window.heroSlider.slides[window.heroSlider.slideIndex - 1].id}`);
      window.heroSlider.e_hashChange();
      window.scrollTo({top: 0, behavior: 'instant'});
    }
  }

  updateStyleScroll() {
    this.toggleSidenav();
    window.heroSlider.inAnimation = true;
    let index = window.heroSlider.slideIndex;

    if (index > 0) {
      window.heroSlider.styleRef.innerHTML = `:root {--slider-offset: calc((100dvh - var(--theme-header-height)) * -${index});}`
    } else if (index == 0) {
      window.heroSlider.styleRef.innerHTML = `:root {--slider-offset: 0px;}`
    }

    setTimeout(() => {
      window.heroSlider.inAnimation = false;

      if (window.heroSlider.slideIndex == window.heroSlider.slides.length) {
        document.body.classList.remove('scroll-disabled');
        window.heroSlider.shouldAnimate = false;
      } else {
        window.scrollTo({top: 0, behavior: 'instant'});
        document.body.classList.add('scroll-disabled');
        window.heroSlider.shouldAnimate = true;
      }
    }, 700);
  }

} export default HeroSlider;
